document.addEventListener("DOMContentLoaded", function() {
    var header = document.querySelector(".header");

    // Publish the header's height as --header-height so CSS can size against
    // it. The full-screen video hero needs `100dvh - header`, and the header
    // is content-sized (logo + padding) rather than a fixed height, so it has
    // to be measured rather than hardcoded.
    //
    // Only measured on the resting (non-sticky) header: that's the space the
    // hero is actually offset by, since the header is position:relative until
    // you scroll. Re-measuring while sticky would report the smaller padded
    // height and make the hero grow as the page scrolls.
    function publishHeaderHeight() {
        if (!header || header.classList.contains("sticky")) return;
        document.documentElement.style.setProperty(
            "--header-height",
            Math.round(header.getBoundingClientRect().height) + "px"
        );
    }

    publishHeaderHeight();

    var resizeTimer;
    window.addEventListener("resize", function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(publishHeaderHeight, 150);
    });

    // When you scroll down add a sticky class to the header
    window.onscroll = function() {
        if (!header) return;
        if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
            header.classList.add("sticky");
        } else {
            header.classList.remove("sticky");
        }
    }
});
